"use client";
import BodyLineText from "@/components/common/text/bodyline-text";
import HeadlineText from "@/components/common/text/headline-text";
import ScreenLayout from "@/components/layout/screen-layout";
import { ImgAboutUsWhyChooseUs } from "@/lib/images";
import Image from "next/image";

function CardsGrid() {
    return (
        <div className="md:pb-17.5 pb-9">
            <ScreenLayout>
                {/* Section Header */}
                <div className="text-center mb-16 flex flex-col items-center justify-center">
                    <HeadlineText>Because Your Vision Deserves Better Execution</HeadlineText>
                    <BodyLineText className="">
                        Experience the difference of working with a team that truly understands your vision. We don't just build software – we craft digital experiences that transform your business and exceed your expectations.
                    </BodyLineText>
                </div>

                <div className="relative flex justify-center">
                    <Image
                        src={ImgAboutUsWhyChooseUs}
                        alt="Why Choose Devkrest"
                        width={1200}
                        height={600}
                        className="w-full h-auto object-cover"
                        priority
                    />
                </div>
            </ScreenLayout>
        </div>
    );
}

export default CardsGrid; 